import { App } from "../Enums/App";
import { MobilyticsQueryParam } from "../Models/MobilyticsQueryParam";
import {
    DoPlaceSearchAction,
    DoLatLngSearchAction,
    DO_PLACE_SEARCH,
    DO_LATLNG_SEARCH,
    DO_LOAD_LOCATIONS,
} from "../Types/PlaceSearchTypes";

export const doPlaceSearch = (app: App, placeId: string, sessionToken: google.maps.places.AutocompleteSessionToken = null): DoPlaceSearchAction => ({
    type: DO_PLACE_SEARCH,
    data: {
        app,
        sessionToken: sessionToken || new google.maps.places.AutocompleteSessionToken(),
        placeId,
    },
});

export const doLatLngSearch = (lat: number, lng: number) : DoLatLngSearchAction => ({
    type: DO_LATLNG_SEARCH,
    data: {
        lat,
        lng,
    }
});

export const doLoadLocations = (locations: MobilyticsQueryParam[]) => ({
    type: DO_LOAD_LOCATIONS,
    data: {
        locations
    }
});